import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ExpertiseSection from './components/ExpertiseSection';
import WhySection from './components/WhySection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import { useSEO } from '../../utils/seo';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Sigorta360 - Sigorta Sektörüne Özel Dijital Ajans',
    description: 'Sigorta acenteleri için özel dijital pazarlama çözümleri. Sosyal medya yönetimi, Google Ads, web tasarımı, CRM entegrasyonu ve marka kimliği hizmetleri ile acentenizi dijitalde büyütüyoruz. %180 ortalama büyüme garantisi.',
    keywords: 'sigorta dijital ajans, sigorta sosyal medya, sigorta web tasarım, sigorta CRM, sigorta Google Ads, sigorta pazarlama',
    canonical: `${siteUrl}/`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Sigorta360',
      description: 'Sigorta sektörüne özel dijital pazarlama ve teknoloji çözümleri',
      url: siteUrl,
      logo: `${siteUrl}/logo.png`,
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+90-555-123-45-67',
        contactType: 'customer service',
        areaServed: 'TR',
        availableLanguage: 'Turkish'
      },
      sameAs: [
        'https://www.facebook.com/sigorta360',
        'https://www.instagram.com/sigorta360',
        'https://www.linkedin.com/company/sigorta360'
      ],
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'İstanbul',
        addressCountry: 'TR'
      }
    }
  });

  return (
    <div className="min-h-screen bg-platinum">
      <Header />
      <main>
        <HeroSection />
        <ExpertiseSection />
        <WhySection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;